module.exports = __webpack_public_path__ + "static/Top-of-Ipad-a05e2b4b95e2e88bcbb517f909bec282.jpg";